import { ReactElement } from 'react';
import { RouterProvider } from 'react-router-dom';
import { APIProvider } from '@ff-it/api';
import { api, swrOptions } from 'services';
import { router } from 'services/router';
import { SWRConfig } from 'swr/_internal';

function App(): ReactElement {
  return (
    <SWRConfig value={swrOptions}>
      <APIProvider client={api}>
        <RouterProvider
          router={router}
          future={{
            v7_startTransition: true,
          }}
        />
      </APIProvider>
    </SWRConfig>
  );
}

export default App;
